import React from 'react';
import PropTypes from "prop-types";

require('./Textarea.scss');

// The `notes` field (and similar) can arrive as a list of note objects
// ({ text, date, deleted, ... }) instead of a string. A <textarea> / view-mode
// <ul> can't render objects, so coerce any array value into a string here.
const toStringValue = (value) => {
    if (Array.isArray(value)) {
        return value
            .filter((item) => item && item.deleted !== true && item.deleted !== "1")
            .map((item) => (item && typeof item === "object" ? item.text : item))
            .filter(Boolean)
            .join("\n");
    }
    return value;
};

const Textarea = ({theme = 'default', id, value, label, maxWidth = 'unset', maxHeight = 'unset', viewMode = false, isList = false, handleParentChange, deleted = false, className = "", classNameModifier="", tooltip, tooltipPosition='up', handleInputFocus, ...rest}) => {
    const disabled = rest.disabled;
    value = toStringValue(value);
    const handleChange = (e) => {
        const key = e.currentTarget.name;
        const value = e.currentTarget.value;
        handleParentChange(key, value);
        return value;
    };

	return (
        <div className={`textarea-container ${theme} ${className}`}>
            {
                label &&
                <label className={`textarea-label ${theme}${disabled ? ' disabled': ''}`}>{label}</label>
            }
            {
                viewMode && tooltip &&
                <span className={`tooltip-new ${tooltipPosition ? tooltipPosition:''}`}>{tooltip}</span>
            }
            {
                !viewMode &&
				<textarea className={`textarea ${theme}${disabled ? ' disabled' : ''} ${classNameModifier}`}
                          id={id}
                          style={{maxWidth: maxWidth, maxHeight: maxHeight}}
                          value={value || ''}
                          onChange={handleChange}
                          {...rest}
                          onFocus={handleInputFocus}
				/>
            }
            {
                viewMode &&
                    <ul className={`${deleted ? "textarea-view-mode-deleted" : ""} display_${classNameModifier} ${!isList ? "list" : ""}`}>
                        {
                            isList && value ?
                                value.split(/\n|\\n/).map((line, index) =>
                                <li key={index}>
                                    {line.length === 1 ? line.replace("-","") : line}
                                </li>) :
                                value || "-"
                        }
                    </ul>
            }
        </div>
    )
};

Textarea.propTypes = {
    theme: PropTypes.oneOf(['default', 'white', 'dark', 'without-border']),
    id: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    label: PropTypes.string,
    maxWidth: PropTypes.string,
    maxHeight: PropTypes.string,
    disabled: PropTypes.bool,
    viewMode: PropTypes.bool,
    handleParentChange: PropTypes.func.isRequired,
    deleted: PropTypes.bool,
    className: PropTypes.string,
    tooltip: PropTypes.string,
    tooltipPosition: PropTypes.oneOf(['up','down']),
    handleInputFocus: PropTypes.func
};

export default Textarea;